import { Grid } from '@mui/material'
import { FormField } from 'global/components/Form'

interface Props {
    labelDataOrigem?: string
}

export default function FormNovaCompensacaoFeriado({
    labelDataOrigem = 'Data do feriado',
}: Props) {
    return (
        <Grid container spacing={2} columns={8}>
            <FormField name="empresaId" sx={{ display: 'none' }} />
            <FormField name="funcionarioId" sx={{ display: 'none' }} />
            <Grid item xs={4}>
                <FormField
                    label="Data em que o funcionário trabalhou"
                    name={'dataCompensacao'}
                    type="date"
                    disabled
                />
            </Grid>
            <Grid item xs={4}>
                <FormField
                    label={labelDataOrigem}
                    name={'dataFeriado'}
                    type="date"
                />
            </Grid>
        </Grid>
    )
}
